export default __webpack_public_path__ + "static/og-img-1.5M-save-the-children-1e0b3ca80ee4818e90f2e59826f3797e.png";